module.exports = __webpack_public_path__ + "img/8.013c73ed.png";